import { mapGetters } from "vuex";
import utils from "@/utils/util";
import pageheader from "@/components/pageheader";
import userService from "@/api/api.service";

export default {
  name: "notifications",
  components: { pageheader },
  data() {
    return {
      input: {},
      tabModel: "tab1",
      colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      editing: null,
      items: [],
      nonce: 1,
      emailsList: [],
      search: null,
      isUpdatingUsers: false,
      isGettingUsers: false,
      notificationID: null,
      notificationType: null,
      toogleSendEmail: false,
    };
  },
  watch: {
    emailsList(val, prev) {
      if (val.length === prev.length) return;

      this.emailsList = val.map((v) => {
        if (typeof v === "string") {
          v = {
            text: v,
            color: this.colors[this.nonce - 1],
          };

          this.items.push(v);

          this.nonce++;
        }

        return v;
      });
    },
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    // getting input content
    this.input = utils.getInputContent("notifications", this.roles);
    //get emails list
    this.getEmailsList();
  },
  methods: {
    filterCombo(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    editCombo(index, item) {
      if (!this.editing) {
        this.editing = item;
      } else {
        this.editing = null;
      }
    },
    async getEmailsList() {
      this.isGettingUsers = true;
      try {
        let response = await userService.getPSNotificationsList();
        if (response.isSuccess && response.data.length > 0) {
          this.toogleSendEmail = response.data[0].sendEmail;
          this.notificationID = response.data[0].id;
          this.notificationType = response.data[0].type;

          this.emailsList = [...response.data[0].emailList];
          this.isGettingUsers = false;
        } else {
          this.emailsList = [];
          this.isGettingUsers = false;
        }
      } catch (err) {
        console.log(err);
        this.isGettingUsers = false;
      }
    },
    async updateEmailsList() {
      this.isUpdatingUsers = true;
      try {
        let payload = {
          id: this.notificationID,
          type: this.notificationType,
          emailList: this.emailsList.map((item) => item.text),
          sendEmail: true,
        };
        let response = await userService.updatePSNotificationsList(
          this.notificationID,
          payload
        );
        if (response.isSuccess) {
          this.isUpdatingUsers = false;
          this.$toast.success(response.systemMessage);
        } else {
          this.isUpdatingUsers = false;
        }
      } catch (err) {
        console.log(err);
        this.isUpdatingUsers = false;
      }
    },
  },
};
